const behaviors = [{
  value: 'Feeding',
  label: 'Feeding'
},{
  value: 'Drinking',
  label: 'Drinking'
},{
  value: 'Exploratory',
  label: 'Exploratory'
},{
  value: 'Social',
  label: 'Social'
},{
  value: 'Locomotion',
  label: 'Locomotion'
},{
  value: 'Proximity',
  label: 'Proximity'
},{
  value: 'Others',
  label: 'Others'
}]

export {behaviors};
